import { render, staticRenderFns } from "./MovementsPagePrimaryMarket.vue?vue&type=template&id=8633df56&"
import script from "./MovementsPagePrimaryMarket.vue?vue&type=script&lang=js&"
export * from "./MovementsPagePrimaryMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports